import * as Constants from '../Constants';

export interface IPolicyStore {
    computedInstanceId: string;
}

const defaultState = {
    computedInstanceId: '',
};

const policy = (state: IPolicyStore = defaultState, action: any) => {
    switch (action.type) {
        case Constants.RESET_POLICY:
            return {
                ...state,
                computedInstanceId: action.computedInstanceId,
            };
        default:
            return state;
    }
};

export default policy;
